<template>
  <div id="wrapper">
    <w-frame-header />
    <w-frame-menu />
    <w-frame-main v-if="!showForcePassword" />
    <w-action-progress v-if="!showSettingView" />
    <!-- <w-frame-main v-if="!showSettingView"/> -->
    <!-- overflow-hidden; 없애면 스크롤 생김 -->
    <w-force-password-change-popup ref="forcePasswordChangePopup" @change-password="changePasswordRes"></w-force-password-change-popup>
    <w-push-notification ref="pushNotification" />
    <w-fault-analysis-popup :is-frame-popup="true" />
    <w-event-smart-analyzer-popup />
    <w-bookmark-popup />
    <w-user-sliding-popup :is-frame-popup="true" />
    <w-smart-search-popup ref="smartSearchPopup"/>
    <!-- 푸시알림 연계 팝업 -->
    <w-common-event-hist-popup :is-frame-popup="true" />
    <w-regular-check-detail-info-popup :is-frame-popup="true" />
    <w-work-detail-popup :is-frame-popup="true" />
    <w-work-details-sliding-popup :is-frame-popup="true" />
    <w-event-timeline-popup :is-frame-popup="true" />
  </div>
</template>

<script>
import { isEmpty, isNil } from 'lodash';
import moment from 'moment';
import OperationSettingsAPI from '@/api/settings/common/operation-settings';
import FrameApi from '@/api/frame/common';
import LoginAPI from '@/api/login';
import UserAPI from '@/api/frame/user';
import msgUtil from '@/utils/message';
import { isTrue } from '@/utils/boolean';
import { closeOpenFramePopup } from '@/utils/popup';
import WActionProgress from '@/components/progressbar/ActionProgress';
import WFaultAnalysisPopup from '@/components/popup/FaultAnalysisPopup';
import WEventSmartAnalyzerPopup from '@/components/popup/EventSmartAnalyzerPopup';
import WCommonEventHistPopup from '@/components/popup/CommonEventHistPopup';
import WRegularCheckDetailInfoPopup from '@/components/popup/RegularCheckDetailInfoPopup';
import WWorkDetailPopup from '@/components/popup/WorkDetailPopup';
import WWorkDetailsSlidingPopup from '@/components/popup/WorkDetailsSlidingPopup';
import WEventTimelinePopup from '@/components/popup/EventTimelinePopup';
import WFrameHeader from './components/FrameHeader';
import WFrameMenu from './components/FrameMenu';
import WFrameMain from './components/FrameMain';
import WPushNotification from './components/PushNotification';
import WBookmarkPopup from './components/popup/BookmarkPopup';
import WSmartSearchPopup from './components/popup/SmartSearchPopup';
import WUserSlidingPopup from './components/popup/UserSlidingPopup';
import WForcePasswordChangePopup from './components/popup/ForcePasswordChangePopup';

export default {
  name: 'WFrame',
  components: {
    WFrameHeader,
    WFrameMenu,
    WFrameMain,
    WActionProgress,
    WPushNotification,
    WFaultAnalysisPopup,
    WEventSmartAnalyzerPopup,
    WCommonEventHistPopup,
    WRegularCheckDetailInfoPopup,
    WWorkDetailPopup,
    WWorkDetailsSlidingPopup,
    WEventTimelinePopup,
    WBookmarkPopup,
    WUserSlidingPopup,
    WForcePasswordChangePopup,
    WSmartSearchPopup,
  },
  data() {
    return {
      webSocket: null,
      showForcePassword: true,
    };
  },
  computed: {
    showSettingView() {
      return this.$store.state.common.showSettingView;
    },
    dynamicTreeFlag() {
      return this.$store.state.tree.dynamicTreeFlag;
    },
    disablePhysicalTreeFlag() {
      return this.$store.state.tree.disablePhysicalTreeFlag;
    },
    staticPhysicalTreeFlag() {
      return this.dynamicTreeFlag === false && this.disablePhysicalTreeFlag === false;
    },
    /**
     * 로그인한 계정의 비밀번호 변경 권고/강제 여부 정보
     */
    passwordPolicy() {
      return this.$store.state.user.passwordPolicy;
    },
    /**
     * 로그인한 계정 정보
     */
    userInfo() {
      return this.$store.getters.userInfo;
    },
  },
  watch: {
    showSettingView: {
      handler(to, from) {
        closeOpenFramePopup();
        if (from && !to) {
          if (this.dynamicTreeFlag === false) {
            this.loadLogicalTreeData();
            if (this.disablePhysicalTreeFlag === false) {
              this.loadPhysicalTreeData();
            }
          }
          this.loadEventlevelInfo();
          this.loadUrgencyAndImpactBasicData();
        }
      },
    },
    dynamicTreeFlag: {
      immediate: true,
      handler(to) {
        if (to === false) {
          this.loadLogicalTreeData();
        }
      },
    },
    staticPhysicalTreeFlag: {
      immediate: true,
      handler(to) {
        if (to === true) {
          this.loadPhysicalTreeData();
        }
      },
    },
  },
  created() {
    this.loadInitSettings();
    this.loadInitBasicinfos();
    // TODO: 이벤트 등급 정보 갱신 주기 정의 및 이벤트 등급 정보가 변경됐을 때 해당 객체 참조하는 각 화면들이 자동으로 update 되는지 확인.
    this.loadEventlevelInfo();
    this.$store.dispatch('loadActiveManagetypes');
    this.openWebSocket();
  },
  mounted() {
    this.checkPasswordPolicy();
  },
  beforeDestroy() {
    this.$refs.pushNotification.cleanPushNotification();
    this.closeWebSocket();
    // 10분 주기로 수행하는 웹 소켓 연결에 대한 헬스 체크 task 제거
    this.$taskManager.removeTask('pushNotificationHealthCheckTask');
  },
  methods: {
    /**
     * 논리 그룹 트리 데이터를 로드한다..
     * @author Ju
     * @return {[type]} [description]
     */
    loadLogicalTreeData() {
      this.$store.dispatch('loadLogicalTreeData');
    },
    /**
     * 물리 그룹 트리 데이터를 로드한다..
     * @author Ju
     * @return {[type]} [description]
     */
    loadPhysicalTreeData() {
      this.$store.dispatch('loadPhysicalTreeData');
    },
    /**
     * 이벤트 등급 정보를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadEventlevelInfo() {
      this.$store.dispatch('loadEventlevelInfo');
    },
    /**
     * 초기 설정 정보를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadInitSettings() {
      FrameApi.getInitSettings().then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          const data = response.data.data;
          this.$store.commit('setDynamicTreeFlag', isTrue(data.DYNAMIC_TREE_FLAG));
          this.$store.commit('setDisablePhysicalTreeFlag', isTrue(data.PHYSICAL_TREE_DISABLE_FLAG));
          this.$store.commit('setTreeSearchKeywordLimitLength', data.TREE_SEARCH_MIN_LENGTH);
          this.$store.commit('setCustomerId', data.CUSTOMER_ID);
          this.$store.commit('setFileMaxMbSize', data.MAX_FILE_SIZE);
          this.$store.commit('setAnalysisTimetype', data.ANALYSIS_TIMETYPE);
        }
      });
    },
    /**
     * 초기 기준 정보를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadInitBasicinfos() {
      FrameApi.getInitBasicinfos().then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          const data = response.data.data;
          this.$store.commit('setTreeSearchUnableKeywords', data.TREE_SEARCH_UNABLE_KEYWORD);
          this.$store.commit('setUrgencyData', data.URGECY_DATA);
          this.$store.commit('setImpactData', data.IMPACT_DATA);
        }
      });
    },
    /**
     * 긴급도 / 영향도 기준정보를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadUrgencyAndImpactBasicData() {
      OperationSettingsAPI.getUrgencyAndImpactBasicData().then((res) => {
        if (res.data.success) {
          this.$store.dispatch('setUrgencyData', res.data.data.urgencyList);
          this.$store.dispatch('setImpactData', res.data.data.impactList);
        }
      });
    },
    /**
     * 푸시 알림을 위한 웹 소켓을 연결하고, 연결에 대한 헬스 체크 수행 시작
     * @author jeee12
     */
    openWebSocket() {
      const protocol = window.location.protocol.indexOf('https') > -1 ? 'wss' : 'ws';
      const url = `${protocol}://${window.location.host}/push-notification.do`;

      this.connectWebSocket(url);
      // 10분 주기로 수행하는 웹 소켓 연결에 대한 헬스 체크 task 생성
      this.$taskManager.createTask('pushNotificationHealthCheckTask', 600, () => {
        if (isNil(this.webSocket) || (this.webSocket && this.webSocket.readyState !== 1)) {
          this.connectWebSocket(url);
        }
      });
    },
    /**
     * 웹 소켓 연결
     * @author jeee12
     * @param  {[type]} url [description]
     */
    connectWebSocket(url) {
      this.closeWebSocket();

      this.webSocket = new WebSocket(url);
      if (this.webSocket) {
        this.webSocket.onmessage = (e) => {
          const result = JSON.parse(e.data);
          this.$refs.pushNotification.setPushNofiticationMessage(result);
        };
        this.webSocket.onerror = () => {
          if (this.webSocket && this.webSocket.readyState !== 1) {
            this.connectWebSocket(url);
          }
        };
      }
    },
    /**
     * 푸시 알림을 위한 웹 소켓 연결 해제
     * @author jeee12
     */
    closeWebSocket() {
      if (this.webSocket) {
        this.webSocket.close();
        this.webSocket = null;
      }
    },
    /**
     * 계정의 비밀번호 변경 여부를 체크한다.
     * @author Ju
     */
    checkPasswordPolicy() {
      /**
       * 패스워드 정책 정보(권고/강제)를 로드한다. (FrameHeader에 구현되었던 비밀번호 권고/강제 팝업 코드)
       * 재로드 (F5)시 패스워드 권고/강제를 띄워야하지만 세션로그인의 경우 passwordPolicy값이 초기화되어 아래 요청을 추가
       * (로그인 매커니즘을 변경하기 보다는 vuex 활용토록 협의) 2019. 12. 11 (Song)
       */
      LoginAPI.getMgrPasswordPolicyData().then((res) => {
        if (res.data.success) {
          const passwordPolicy = res.data.data;
          if (!isEmpty(passwordPolicy)) {
            const passwordChangeDatetime = this.userInfo.passwordChangedDatetime;
            let pwChangeDay;
            if (!isNil(passwordChangeDatetime)) {
              const changeDate = moment(passwordChangeDatetime);
              const today = moment();
              pwChangeDay = Math.floor(moment.duration(today.diff(changeDate)).asDays());
            } else {
              pwChangeDay = 0;
            }

            const messageOptions = {
              confirmButtonText: '변경',
              dangerouslyUseHTMLString: true,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              closeOnHashChange: false,
              showClose: false,
            };

            if (passwordPolicy.forcePasswordChangeFlag === true) {
              // 비밀번호 변경 강제
              this.$alert(`비밀번호를 변경한지 ${pwChangeDay}일이 지났습니다.<br/>비밀번호를 변경해야합니다.`, '비밀번호', messageOptions).then(() => {
                this.$refs.forcePasswordChangePopup.open(pwChangeDay);
              });
            } else if (passwordPolicy.passwordChangeFlag === true) {
              const passwordChangePeried = passwordPolicy.passwordChangePeried || '-';
              // 비밀번호 변경 권고
              this.$confirm(`비밀번호를 변경한지 ${pwChangeDay}일이 지났습니다.<br/>비밀번호를 변경하시겠습니까?`, '비밀번호', {
                cancelButtonText: `${passwordChangePeried}일 뒤에 변경`,
                ...messageOptions,
              })
                .then(() => {
                  this.$refs.forcePasswordChangePopup.open(pwChangeDay);
                })
                .catch(() => {
                  const params = {
                    managerId: this.userInfo.managerId,
                    passwordChangedDatetime: new Date(),
                  };
                  UserAPI.updatePasswordChangedDate(params)
                    .then((response) => {
                      if (response.data.success) {
                        this.$message(msgUtil.getCustomResultMsgData(`${passwordChangePeried}일 뒤로 연기하였습니다.`, true));
                      } else {
                        this.$message(msgUtil.getCustomResultMsgData('비밀번호 변경 권고 일자를 연기하지 못하였습니다.', false));
                      }
                    })
                    .catch((e) => {
                      this.$message(msgUtil.getCustomResultMsgData('비밀번호 변경 권고 일자를 연기하지 못하였습니다.', false));
                      throw new Error(e);
                    })
                    .finally(() => {
                      this.showForcePassword = false;
                    });
                });
            } else {
              this.showForcePassword = false;
            }
          } else {
            this.showForcePassword = false;
          }
        }
      });
    },
    /**
     * 권고/강제 패스워드 변경 완료 호출
     * @author Song
     */
    changePasswordRes() {
      this.showForcePassword = false;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/frame/index.vue